import { render } from "./BasePlannerRoom.vue?vue&type=template&id=49ff60bc"
import script from "./BasePlannerRoom.vue?vue&type=script&lang=js"
export * from "./BasePlannerRoom.vue?vue&type=script&lang=js"

import "./BasePlannerRoom.vue?vue&type=style&index=0&id=49ff60bc&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__